module.exports = __webpack_public_path__ + "img/db_check.955cb399.svg";